import { useEffect, useRef, useState } from "react";

const useTimer = (): {
  time: number;
  isRunning: boolean;
  startTimer: () => void;
  pauseTimer: () => void;
  resumeTimer: () => void;
  resetTimer: () => void;
} => {
  const [time, setTime] = useState<number>(0);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const timerRef = useRef<number | null>(null);
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const startTimer = (): void => {
    if (!isRunning) {
      setIsRunning(true);
      timerRef.current = window.setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
  };

  const pauseTimer = (): void => {
    if (isRunning && timerRef.current) {
      window.clearInterval(timerRef.current);
      setIsRunning(false);
    }
  };

  const resumeTimer = (): void => {
    if (!isRunning) {
      setIsRunning(true);
      timerRef.current = window.setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
  };

  const resetTimer = (): void => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    setTime(0);
    setIsRunning(false);
  };

  return {
    time,
    isRunning,
    startTimer,
    pauseTimer,
    resumeTimer,
    resetTimer,
  };
};

export default useTimer;
